import { Dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan';
import { ComponentDescription } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import mapComponentDescriptionsByName from './mapComponentDescriptionsByName';

/**
 * Given a DOLAN returns all the component descriptions
 * in a mapping where keys are the unique `name` identifiers.
 * @param dolan The DOLAN structure
 * @returns Component descriptions mapped by their `name` identifiers
 */
export default function getComponentDescriptionsByName(
  dolan: Dolan | null | undefined,
): Record<string, ComponentDescription> {
  return mapComponentDescriptionsByName(dolan?.components);
}
